import styled from 'styled-components';

const sizes = {
    small: '0.6rem',
    medium: '1rem',
    large: '1.4rem',
} as const;

export type StatusTagSize = keyof typeof sizes;

export const StyledStatus = styled.div`
    display: flex;
    align-items: center;
    gap: 0.8rem;
`;

export const StyledStatusTag = styled.span<{ color: string | (() => string); $size: StatusTagSize }>`
    background-color: ${({ color }) => color};
    width: ${({ $size }) => sizes[$size]};
    height: ${({ $size }) => sizes[$size]};
    min-height: ${({ $size }) => sizes[$size]};
    min-width: ${({ $size }) => sizes[$size]};
    border-radius: 50%;
`;
